import { render, staticRenderFns } from "./AccountVerify.vue?vue&type=template&id=5bed489e&"
import script from "./AccountVerify.vue?vue&type=script&lang=js&"
export * from "./AccountVerify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports